module.exports = __webpack_public_path__ + "img/my.70194c65.png";